import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/dataDisplay/teamWeb",
  component: function component() {
    return import("../../../views/dataCenter/teamWeb.vue");
  },
  name: "teamWeb",
  meta: {
    title: "我的团队"
  }
}, {
  path: "/dataDisplay/index",
  component: function component() {
    return import("../../../views/dataCenter/dataDisplay.vue");
  },
  name: "teamWebDataDisplay",
  meta: {
    title: "我的团队"
  }
}];